import { FaRegCircleCheck } from 'react-icons/fa6';

const RegisterSuccess = () => {
  return (
    <div className="h-[405px] flex flex-col gap-5 items-center justify-center">
      <FaRegCircleCheck size={80} color="green" />
      <h4 className="text-2xl text-[var(--mantine-primary-color-filled)]">
        Form submitted successfully.
      </h4>
    </div>
  );
};

export default RegisterSuccess;
